import styled from '@emotion/styled';
import Card from '@portalterreno/react-ui-core/Card';

const StyledCard = styled(Card)({
  paddingLeft: 28,
  paddingRight: 28,
  paddingTop: 25,
  paddingBottom: 25,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'visible',
  boxShadow: '0 10px 24px 0 rgba(155, 165, 177, 0.2)'
});

export default StyledCard;
